import { Chip, List, ListItem, ListItemText, styled, TextField, Tooltip } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { TypeOption } from "components/app/BaseMultipleAutocomplete/BaseMultipleAutocomplete";
import { FC, useState } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";

interface ActivityLookupCompleteProps {
  category: "ACTIVITY_TYPE" | "ACTIVITY_PRODUCT" | "ACTIVITY_PURPOSE";
  field: ControllerRenderProps;
  fieldState: ControllerFieldState;
  label: string;
  ops: TypeOption[];
  fullWidth?: boolean;
  showMarginLeft?: boolean;
  hideTitle?: boolean;
  disabled?: boolean;
  handleChange?: (selected: { value: string; name: string } | null) => void;
}

const StyledChip = styled(Chip)({
  fontSize: "0.2rem",
  margin: 2,
});

const ActivityLookupComplete: FC<ActivityLookupCompleteProps> = ({
  field,
  fieldState,
  label,
  ops,
  fullWidth = false,
  showMarginLeft = false,
  hideTitle = false,
  disabled = false,
  handleChange,
}) => {
  //const { typeOptions, purposeOptions } = useContext(ActivityLookupContext);

  const [value, setValue] = useState<TypeOption | null>(field.value);
  const [inputValue, setInputValue] = useState("");
  //const [options, setOptions] = useState<TypeOption[]>([]);

  /* useEffect(() => {
    setOptions(category === "ACTIVITY_TYPE" ? typeOptions : purposeOptions);
  }, [field?.value]); */

  const onChange = (_e: any, value: TypeOption | null) => {
    setValue(value);
    field.onChange(value);
    handleChange?.(value);
  };

  return (
    <div
      style={{
        marginTop: 8,
        flexBasis: fullWidth ? undefined : "49%",
        marginLeft: showMarginLeft ? "2%" : 0,
        width: fullWidth ? "100%" : undefined,
      }}
    >
      {label && (
        <p
          style={{
            fontSize: 12,
            color: "#535759",
            fontWeight: 500,
            display: "flex",
          }}
        >
          <span style={{ color: "#FF5F58", fontSize: "1rem", marginRight: 4 }}>*</span>
          {label}
        </p>
      )}
      <Autocomplete
        {...field}
        getOptionLabel={(option) => option.value}
        loading={ops === undefined}
        blurOnSelect={false}
        clearOnBlur={false}
        multiple={false}
        limitTags={1}
        size={"small"}
        disabled={disabled}
        isOptionEqualToValue={(o, v) => o.name === v.name}
        options={ops}
        inputValue={inputValue}
        onInputChange={(_, value) => setInputValue(value)}
        renderOption={(props, option) => (
          <li {...props}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p>{option.value}</p>
            </div>
          </li>
        )}
        renderTags={(value, getTagProps) => (
          <div>
            <StyledChip
              label={value?.[0].value}
              {...getTagProps({ index: 0 })}
              size={"small"}
            />
            {value.length > 1 ? (
              <Tooltip
                title={
                  <List
                    disablePadding={true}
                    dense={true}
                  >
                    {value.slice(1).map((x) => (
                      <ListItem
                        dense={true}
                        key={x.name}
                      >
                        <ListItemText primary={x.value} />
                      </ListItem>
                    ))}
                  </List>
                }
              >
                <Chip
                  size={"small"}
                  label={`${value.length - 1} more`}
                />
              </Tooltip>
            ) : null}
          </div>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            margin="normal"
            variant="outlined"
            classes={{ root: "dropdown-multiple-option" }}
            InputProps={{
              ...params.InputProps,
              type: "search",
              style: {
                width: fullWidth ? "100%" : hideTitle ? 245 : showMarginLeft ? "100%" : "98%",
                marginTop: -15,
                background: "#fff",
              },
            }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            size={"small"}
            placeholder={"Please select"}
          />
        )}
        onChange={onChange}
        value={field.value ?? value}
      />
    </div>
  );
};

export default ActivityLookupComplete;
